import { useEffect, useContext } from 'react';
import { TutorialContext } from '../components/TutorialProvider';
import { TutorialKey } from '../types/Tutorial';

interface UseTutorialOptions {
  hasData?: boolean;
}

export function useTutorial(key: TutorialKey, options: UseTutorialOptions = {}) {
  const context = useContext(TutorialContext);
  const { hasData = true } = options;

  useEffect(() => {
    if (!context) return;
    if (!context.shouldShowTour(key)) return;
    if (!hasData) return;

    const timer = setTimeout(() => {
      context.startTour(key);
    }, 500);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, hasData]);

  return context;
}
